import "./footer.scss";
import { Link } from "react-router-dom";

function Footer() {
    return (
        <footer>
            <div className="">
                <h2>amaSocial</h2>
                <p>
                    It helps social media marketers, community managers and analysts to measure social media activity on Facebook, X, Instagram and YouTube, as well as mentions on blogs. With amaSocial, your business can track its social
                    media ROI by monitoring @handles, campaign phrases, #hashtags, profiles, URLs and topics on social media platforms and blogs.
                </p>
            </div>
            <div className="">
                <h2>Services</h2>
                <Link to="/services#keyword-tracking">Keyword Tracking</Link>
                <Link to="/services#reaction-lists">Reaction Lists</Link>
                <Link to="/services#hourly-insights">Hourly Insights</Link>
                <Link to="/services#content-verification">Content Verification</Link>
                <Link to="/services#engagement-metrics">Engagement Metrics</Link>
                <Link to="/services#reports">On-demand Reports</Link>
            </div>
            <div className="">
                <h2>Legal</h2>
                <a href="/policy">Policies</a>
            </div>
            <div className="">
                <h2>Contact Info</h2>
                <p>010 020 5255</p>
                <a href="mailto:hello@amasocial.co.za">hello@amasocial.co.za</a>
                <Link to="/">www.amasocial.co.za</Link>
                <p className="address">23 J.G Strydom Rd</p>
                <p className="address">Constantia Kloof</p>
                <p className="address">Roodepoort</p>
                <p className="address">1709</p>
            </div>
        </footer>
    );
}

export default Footer;
